import { useState } from 'react';

// Checkbox multi-select for a table of items, keyed by uid.
// Same select-all/select-one behavior previously copy-pasted across every AdminComponents *ListResults.jsx.
export function useRowSelection(items, getId = (item) => item.uid) {
    const [selectedIds, setSelectedIds] = useState([]);

    const handleSelectAll = (event) => {
        setSelectedIds(event.target.checked ? items.map(getId) : []);
    };

    const handleSelectOne = (event, id) => {
        setSelectedIds((selectedIds) => {
            const selectedIndex = selectedIds.indexOf(id);

            if (selectedIndex === -1) {
                return selectedIds.concat(id);
            } else if (selectedIndex === 0) {
                return selectedIds.slice(1);
            } else if (selectedIndex === selectedIds.length - 1) {
                return selectedIds.slice(0, -1);
            }
            return selectedIds.slice(0, selectedIndex).concat(selectedIds.slice(selectedIndex + 1));
        });
    };

    return { selectedIds, handleSelectAll, handleSelectOne };
}
